import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";
import Quotation, { QuotationStyles } from "./Quotation.jsx";
import Grider, { GriderStyles } from "./Grider.jsx";

export function BlockFeedbacksStyles(params = {}) {
    return {
        "& .block-feedbacks": {
            padding: "0 20px",
            margin: "0 auto",
            maxWidth: "1200px",
        },

        ...GriderStyles(params),
        ...QuotationStyles(params),
    };
}

export default function BlockFeedbacks(props) {
    const { Feedbacks } = props.variables;
    const LI = useLoremIpsum();

    const _Feedbacks = Feedbacks || LI.Feedbacks;
    if (!Array.isArray(_Feedbacks)) {
        console.warn("_Feedbacks is not array!");
        return null;
    }

    const elProps = toElementProps(props, { className: ["block-feedbacks"] });
    return (
        <div {...elProps}>
            <Grider mode="flex-wrap">
                {_Feedbacks?.map((quote, index) => {
                    const reverse = index % 2 !== 0;
                    return <Quotation key={index} variant={props.variant} reverse={reverse} {...quote} />;
                })}
            </Grider>
        </div>
    );
}
